import { lazy } from "react";
import { Toaster } from "sonner";

import FlashManager from "components/background/FlashManager";
import MobileManagerWrapper from "components/background/MobileManagerWrapper";
import LoginModal from "components/join/LoginModal";
import ReportModal from "components/ReportDropdown/Report/ReportModal";
import QuickSearchModal from "components/search/QuickSearchModal";
import Suspense from "components/shared/Suspense";
import { useIsScreenSizeBiggerThanTailwindSize } from "hooks/useIsScreenSizeBiggerThanTailwindSize";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";

const ResponsiveTooltip = lazy(() => import("./ResponsiveTooltip"));

const SharedPlaceholders = () => {
  const isLoggedIn = useIsLoggedIn();
  const isLarge = useIsScreenSizeBiggerThanTailwindSize("lg");

  return (
    <>
      <QuickSearchModal />
      {isLoggedIn === false && <LoginModal />}
      <ReportModal />
      {isLarge && (
        <Suspense>
          <ResponsiveTooltip />
        </Suspense>
      )}
      <Toaster
        position="top-right"
        expand
        closeButton
        duration={3000}
        visibleToasts={3}
        toastOptions={{
          unstyled: true,
          classNames: {
            closeButton: "bg-foreground",
            toast:
              "flex items-center rounded-xl w-full p-2 border-2 text-base mt-12 gap-0.5",
            error: "bg-red-500 border-red-400 text-red-50",
            success: "bg-green-400 border-green-600 text-green-900",
            warning: "bg-yellow-400 border-yellow-600 text-yellow-900",
            info: "bg-blue-400 border-blue-600 text-blue-900",
          },
        }}
      />
      <MobileManagerWrapper />
      <FlashManager />
    </>
  );
};

export default SharedPlaceholders;
